<template>
  <div class="dialog-viewer-picture" :class="{ 'android-padding': isAndroid, 'ios-padding': isIOS }">
    <header>
      <div class="viewer-app-tip">
        <span
          class="icon-btn" title="下载"
          @click="onDownload"
        >
          <SVGIcon name="preview-download" />
        </span>
        <span
          class="icon-btn" title="删除"
          @click="onDelete"
        >
          <SVGIcon name="preview-delete" />
        </span>
        <span
          class="icon-btn" title="关闭"
          @click="$emit('close')"
        >
          <SVGIcon name="preview-close" />
        </span>
      </div>
    </header>
    <div class="viewer-inner">
      <span
        class="xlp-btn-pic-pre" 
        :class="{ hidden: index === 0 || index === -1 }"
        @click="onPre"
        title="上一张"
      >
        <SVGIcon name="preview-prev" />
      </span>
      <span class="xlp-play-loading__icon" v-show="!show" />
      <TdViewerImage
        v-if="currentItem.media === 2"
        :src="imgSrc" 
        :visible="show"
      />
      <TheViewerVideo 
        :id="currentItem.md5sum"
        :preview-file-info="videoInfo"
        :default-cover="imgSrc"
        :video-duration="formatLastTime(currentItem.duration)"
        v-else
      />
      <span
        class="xlp-btn-pic-next" 
        :class="{ hidden: index === images.length - 1 || index === -1 }"
        @click="onNext"
        title="下一张"
      >
        <SVGIcon name="preview-next" />
      </span>
    </div>
  </div>
</template>
<script>

import { useStore } from 'vuex'
import { isAndroidNative as isAndroid, isIOSNative as isIOS } from '@xunlei/universal-native-api'
import { useAlbumStore } from '@remote/store/album'
import { downloadPhoto } from '@remote/store/album/helper'
import TdViewerImage from './TdViewerImage'
import SVGIcon from '@remote/components/SVGIcon.vue'
import { getFileInfoToPreview } from '@remote/store/hezi-file'
import { pathJoin } from '@remote/utils/file-helper'
import TheViewerVideo from './TheViewerVideo.vue'
import { formatLastTime } from '@remote/utils'
import Modal from '@remote/components/modal'

export default {
  components: {
    TdViewerImage,
    TheViewerVideo,
    SVGIcon,
  },
  props: {
    id: {
      type: String,
      default: '0',
    },
    previewFileInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  emits: ['close'],
  setup () {
    const store = useStore()
    const { 
      data, 
      subPathData ,
      deletePhoto,
      downloadPhotos,
    } = useAlbumStore()
    if (subPathData.subPath) {
      return { store, list: subPathData.list, isAndroid, isIOS, deletePhoto, downloadPhotos, subPath: subPathData.subPath, formatLastTime }
    } else {
      return { store, list: data.list, isAndroid, isIOS, deletePhoto, downloadPhotos, subPath: '', formatLastTime  }
    }
  },
  data () {
    return {
      qrcode: require('@remote/assets/images/web/qrcode.png'),
      index: 0,
      pid: '',
      show: false,
      isFirst: true,
      fallbackResource: null,
      currentItem: {},
      videoInfo: null,
      images: [],
    }
  },
  computed: {
    imgSrc () {
      return this.currentItem?.cover || this.fallbackResource?.cover
    },
  },
  watch: {
    imgSrc: {
      async handler (val) {
        if (!val) return console.warn('cover not exit')
        this.width = 0
        this.scale = 1
        this.rotate = 0
        const img = new Image()
        img.onload = async () => {
          this.show = true
        }
        img.src = val
        this.show = img.complete
      },
      immediate: true,
    },
  },
  created () {
    this.images = [...this.list] 
    this.index = this.images.findIndex(item => item.md5sum === this.id)
    this.load()
    this.$stat('pc_yunpan_web', 'yunpan_web_photo_browser_show')
  },
  methods: {
    onPre () {
      this.show = false
      this.fallbackResource = null
      if (this.index >= 1) {
        this.index -= 1
      } else {
        this.index = this.images.length - 1
      }
      this.load()
    },
    onNext () {
      this.show = false
      this.fallbackResource = null
      if (this.index >= this.images.length - 1) {
        this.index = 0
      } else {
        this.index += 1
      }
      this.load()
    },
    load () {
      this.currentItem = this.images[this.index]
      this.videoInfo = null
      if (this.currentItem && this.currentItem.md5sum) {
        getFileInfoToPreview({
          path: pathJoin(this.subPath, this.currentItem.rel_path),
          md5sum: this.currentItem.md5sum,
          size: this.currentItem.size,
          hash: '',
        })
          .then(res => {
            if (res && res.id === this.currentItem.md5sum) {
              this.fallbackResource = res
              if (this.currentItem.media === 1) {
                this.videoInfo = res
              } else {
                const img = new Image()
                img.onload = async () => {
                  if (res.id === this.currentItem.md5sum) this.currentItem.cover = res.web_content_link
                }
                img.src = res.web_content_link
              }
            }
          })
      }
    },
    onDownload () {
      downloadPhoto(this.currentItem, this.subPath, true)
    },
    onDelete () {
      const onOk = () => this.deletePhoto(this.currentItem)
        .then(() => {
          this.onNext()
          if(this.index === 0) {
            // 处理删除最后一张
            this.images.splice(this.images.length - 1, 1)
          } else {
            this.index -= 1
            this.images.splice(this.index, 1)
          }
          if (!this.images.length) this.$emit('close')
        })
      Modal.Delete({
        title: '确定删除当前照片吗？',
        cancelText: '取消',
        okText: '删除',
        loadingText: '删除中...',
        hasCheck: false,
        onOk,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-viewer-picture {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 11;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;

  &.android-padding {
    padding: 22px 15px 0;
  }

  &.ios-padding {
    padding: 40px 15px 0;
  }

  header {
    position: absolute;
    width: 100%;
    height: 60PX;
    display: flex;
    align-items: center;
    font-size: 13PX;
    z-index: 1000;
    flex-shrink: 0;
    background: transparent;
    color: #fff;
    .icon-btn {
      margin-right: 16PX;
      display: inline-block;
      width: 36PX;
      height: 36PX;
      border-radius: 50%;
    }
  }

  .viewer-inner {
    display: flex;
    justify-content: center;
    justify-self: center;
    align-items: center;
    flex: 1;
    max-height: 100%;

    .xlp-btn-pic-pre,
    .xlp-btn-pic-next {
      display: inline-block;
      width: 36PX;
      height: 36PX;
      border-radius: 50%;
      cursor: pointer;
      &.hidden {
        visibility: hidden;
      }
      &::before {
        display: none;
      }
    }
    .xlp-btn-pic-pre {
      margin-left: 45PX;
      margin-right: auto;
      left: 0px;
    }

    .xlp-btn-pic-next {
      margin-right: 45PX;
      margin-left: auto;
      right: 0;
    }

    .xlp-play-loading__icon {
      position: absolute;
      top: 50%;
      left: 50%;
      width: 80PX;
      height: 80PX;
      margin-left: -40PX;
      margin-top: -40PX;
      z-index: 1;
    }
  }
}
</style>
